const NotFound: React.FC = () => <div>404</div>;

export default NotFound;
